import * as yup from "yup";

export const ValidateTaxes = yup.object().shape({
    name: yup.string().required("Nome é obrigatório").min(3, "Nome deve ter mais que três caracteres"),
    tax_fees: yup.number().required("Alíquota é obrigatória").moreThan(-1, "Alíquota deve ser maior ou igual a zero"),
    type_calculate: yup.string().required("Tipo cálculo é obrigatório").oneOf(["inside", "outside", "hold"], "Tipo de pagamento inválido"),
});
